import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { getFeaturePlugins } from "plugins/plugin-registry"
import { selectActiveSidePanelModal } from "./slice"
import { activateSidePanelModal } from "./thunks"
import { clearSelection } from "./slice.new"

export function usePluginState(pluginName?: string) {
    const plugins = getFeaturePlugins()
    const pluginsThatSupportSampleData = plugins.filter((plugin) => !!plugin.sampleDataModalName)
    const dispatch = useAppDispatch()
    const activePluginId = useAppSelector(selectActiveSidePanelModal())?.id
    const currentPlugin = plugins.find((p) => p.featureId === activePluginId)

    pluginName = pluginName?.includes("colorfinder") ? "colorfinder" : pluginName
    const selectedPlugin = plugins.find((p) => p.featureId === pluginName)

    const setSelectedPlugin = (pluginId?: string) => {
        dispatch(activateSidePanelModal(pluginId ? { id: pluginId, type: "data" } : undefined))

        // De-select any selected layers if the newly selected plugin will take over the side panel
        // and will cover the layers list.
        const newPlugin = plugins.find((plugin) => plugin.featureId === pluginId)
        if (newPlugin?.sidePanelPluginActionsComponent) dispatch(clearSelection())
    }

    return {
        plugins,
        pluginsThatSupportSampleData,
        currentPlugin,
        setSelectedPlugin,
        selectedPlugin,
    }
}
